var _pattern, _pattern2, _filter, _pattern3, _pattern4, _filter2, _filter3, _filter4, _pattern5, _pattern6, _filter5, _filter6, _pattern7, _pattern8, _filter7, _pattern9, _pattern0, _filter8, _filter9, _filter0, _pattern1, _pattern10, _pattern11, _filter1, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveStartPage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360.39mm",
    height: "358.12mm",
    viewBox: "0 0 360.39 358.12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    width: 4,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 3,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 40,
    fill: "url(#pattern83665-6)"
  }))), _pattern2 || (_pattern2 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83665-6",
    patternTransform: "translate(-4.7363e-8)",
    xlinkHref: "#pattern83571-1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83571-1",
    width: 3,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter28118",
    x: -0.16178,
    y: -0.19168,
    width: 1.4135,
    height: 1.3308,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.9,
    dy: -4,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  }))), _pattern3 || (_pattern3 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83661-2",
    width: 4,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 3,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 40,
    fill: "url(#pattern83665-1)"
  }))), _pattern4 || (_pattern4 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83665-1",
    patternTransform: "translate(-4.7363e-8)",
    xlinkHref: "#pattern83571-9"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83571-9",
    width: 3,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  })), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter101789-4",
    x: -0.13245,
    y: -0.19852,
    width: 1.3278,
    height: 1.4345,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 2,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter15094",
    x: -0.253,
    y: -0.13815,
    width: 1.4043,
    height: 1.3544,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter15154",
    x: -0.16505,
    y: -0.30255,
    width: 1.3419,
    height: 1.5055,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  }))), _pattern5 || (_pattern5 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83661",
    width: 4,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 3,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 40,
    fill: "url(#pattern83665)"
  }))), _pattern6 || (_pattern6 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83665",
    patternTransform: "translate(-4.7363e-8)",
    xlinkHref: "#pattern83571"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83571",
    width: 3,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  })), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "filter13691",
    x: -0.13651,
    y: -0.20532,
    width: 1.2744,
    height: 1.4126,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.34902,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2033-2",
    x: -0.10687,
    y: -0.091942,
    width: 1.2518,
    height: 1.2166,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.34902,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "out",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.5,
    dy: 2.5,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "offset",
    in2: "SourceGraphic",
    operator: "atop",
    result: "composite2"
  }))), _pattern7 || (_pattern7 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83661-0",
    width: 4,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 3,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 40,
    fill: "url(#pattern83665-61)"
  }))), _pattern8 || (_pattern8 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83665-61",
    patternTransform: "translate(-4.7363e-8)",
    xlinkHref: "#pattern83571-8"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83571-8",
    width: 3,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  })), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4256",
    x: -0.27548,
    y: -0.32018,
    width: 1.4615,
    height: 1.6583,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.2,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  }))), _pattern9 || (_pattern9 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83661-4",
    width: 4,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 3,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 40,
    fill: "url(#pattern83665-4)"
  }))), _pattern0 || (_pattern0 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83665-4",
    patternTransform: "translate(-4.7363e-8)",
    xlinkHref: "#pattern83571-50"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83571-50",
    width: 3,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  })), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4164",
    x: -0.092814,
    y: -0.11574,
    width: 1.2189,
    height: 1.2728,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.34902,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "out",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.5,
    dy: 2.5,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "offset",
    in2: "SourceGraphic",
    operator: "atop",
    result: "composite2"
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "filter6631",
    x: -0.33641,
    y: -0.41958,
    width: 1.6902,
    height: 1.8607,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.2,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  }))), _filter0 || (_filter0 = /*#__PURE__*/React.createElement("filter", {
    id: "filter5185",
    x: -0.087393,
    y: -0.1311,
    width: 1.2064,
    height: 1.3091,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.34902,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "out",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.5,
    dy: 2.5,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "offset",
    in2: "SourceGraphic",
    operator: "atop",
    result: "composite2"
  }))), _pattern1 || (_pattern1 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83661-7",
    width: 4,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 3,
    height: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 40,
    fill: "url(#pattern83665-3)"
  }))), _pattern10 || (_pattern10 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83665-3",
    patternTransform: "translate(-4.7363e-8)",
    xlinkHref: "#pattern83571-7"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern83571-7",
    width: 3,
    height: 40,
    patternTransform: "translate(96.091 253.34)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 1,
    height: 40,
    fill: "#f00",
    style: {
      paintOrder: "normal"
    }
  })), _pattern11 || (_pattern11 = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern88495-2",
    patternTransform: "matrix(-17.313 0 0 -4.7273 167.32 50.478)",
    xlinkHref: "#pattern83661-7"
  })), _filter1 || (_filter1 = /*#__PURE__*/React.createElement("filter", {
    id: "filter12129",
    x: -0.12581,
    y: -0.16302,
    width: 1.287,
    height: 1.3158,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.2,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.61 -8.8389)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3885 -.80165 .80165 1.3885 533.73 115.71)",
    fill: "#ccd1dc",
    stroke: "#ccd1dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-321.21-10.179c-23.485 6.0661-30.453-21.351-31.798-45.21-1.2695-22.523 22.579-76.873 65.711-75.54 43.132 1.3329 74.468 22.951 101.74 22.279 27.596-0.68004 45.973-12.35 56.885-22.251 7.2626-6.5904 15.51-10.893 26.266-0.87046 10.247 9.548 17.42 23.89 8.0098 52.555-5.0431 15.363-29.849 64.116-87.201 58.457-56.718-5.5957-50.835-15.705-73.902-16.022-17.309-0.23818-25.508 2.1242-40.552 11.921-6.6255 4.3145-13.431 12.151-25.159 14.683z",
    fill: "#ccd1dc",
    stroke: "#ccd1dc",
    strokeWidth: 1.5389
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.52824 0 0 .52824 6.2193 79.251)",
    filter: "url(#filter15094)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.27751 -.073359 .073359 .27751 200.51 139.2)",
    fill: "#0a0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.3367,0,0,7.3367,-1371,-1543.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4277,0,0,1.4277,14.744,-71.081)",
    filter: "url(#filter28118)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.063501 .12572)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.67257 0 0 .67257 81.042 131.12)",
    filter: "url(#filter15154)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48605 1.814 -1.814 .48605 443.19 -284.1)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#pattern83661-2)",
    strokeWidth: 0.68529
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 147.15)",
    stroke: "#f80000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 167.15)",
    stroke: "#f00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 127.15)",
    stroke: "#f00"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2467,0,0,1.2467,-167.89,-260.03)",
    filter: "url(#filter101789-4)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.65891 0 0 .65891 306.5 -11.283)",
    filter: "url(#filter13691)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.22386 0 0 .22386 118.03 109.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0036488 -1.0849 1.0849 .0036488 269.24 36.123)",
    fill: "#0a0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.3367,0,0,7.3367,-1371,-1543.9)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#pattern83661)",
    strokeWidth: 0.68529
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.1953,0,0,1.1953,394.79,-6.9987)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.19,76.247)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233.36,-76.522)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.85815 0 0 .85815 4.4285 22.6)",
    filter: "url(#filter4256)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.17212 -.0455 .0455 .17212 142.44 149.69)",
    fill: "#0a0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.3367 0 0 7.3367 -1371 -1543.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.77,
    y: 166.17,
    width: 49.135,
    height: 74.135,
    ry: 8.1835,
    fill: "#fff",
    style: {
      paintOrder: "normal"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#pattern83661-0)",
    strokeWidth: 0.68529
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 147.15)",
    stroke: "#f80000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 167.15)",
    stroke: "#f00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 127.15)",
    stroke: "#f00"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-221.51-137.47 130.33 68.949c-65.417 33.662-65.392 33.691-131.23 67.021l-129.49-69.595c64.747-33.577 64.376-33.386 130.39-66.375z",
    fill: "#00d400",
    stroke: "#00d400",
    strokeWidth: 1.0001
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.8855 0 0 .8855 20.021 13.92)",
    filter: "url(#filter2033-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.063501 .12572)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.197 138.02s6.2173-8.1097 10.37-7.0421c3.683 0.94692 2.885 13.447 2.885 13.447",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.075 144.78s-1.8051-12.805 2.6672-14.182c3.7179-1.1447 10.342 6.9931 10.342 6.9931",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.085 137.59s5.144-1.6044 8.4236-1.5921c3.2796 0.0122 7.6888 2.0208 7.6888 2.0208"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.075 144.78c-3.8322 5.8579-5.022 12.282-4.6323 15.373 0.814 6.4554 3.5844 12.722 8.8373 15.686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.452 144.42c3.2116 7.9361 4.5724 11.965 3.4429 16.974s-3.7278 10.854-9.8933 14.072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.493 162.42s3.3069 0.89404 4.6677-2.6944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.161 159.72s1.9596 3.7476 4.7221 2.9148"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.838,
    cy: 156.45,
    rx: 3.2465,
    ry: 3.2685,
    fill: "#000500"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.849,
    cy: 156.79,
    rx: 3.2465,
    ry: 3.2685,
    fill: "#000500"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.293 174.56s-0.74926 11.452 0.67306 16.412 4.559 11.177 6.4258 13.017 6.883 3.4972 9.2451 2.1715c2.3621-1.3258 1.0032-8.2288 0.57147-12 0.07619-0.17144 3.7971 0.11429 3.7971 0.11429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.569 191.89s-0.74925 7.7374-2.3621 10.629c-1.6128 2.8915-8.4704 5.4173-10.35 3.4972-1.8795-1.92-0.85085-11.737-0.85085-11.737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.264 195.17s7.4545-1.2343 9.9689-5.0058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.195 156.62s2.6287-2.6858 3.0224-6.3773c0.39368-3.6915 0.19049-7.1088 1.435-9.4631 1.2445-2.3544 4.013-3.7144 7.4291 1.0629 3.4161 4.7773 2.8065 13.315 2.8065 13.315s0.254 3.4401-4.4574 11.497c0 0 2.6541 9.6345-2.5907 18.149"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m74.801 193.5s-1.7779 4.4458-0.91434 6.663c0.86354 2.2172 8.8133 0.57143 10.02-1.3029 1.2064-1.8743 3.9876-4.823 2.9335-14.058"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-3.1594e-5 -55.178)",
    d: "m77.287 217.84c-0.32516-0.51071-1.2043-1.4808-1.8351-2.025-2.2045-1.9018-4.8496-2.8684-8.3344-3.0456l-0.97568-0.0496 0.04257-0.40731c0.05828-0.55763-0.13022-1.3653-0.44169-1.8925-1.3334-2.2569-4.6405-2.1306-5.7678 0.22033-0.13076 0.27269-0.23775 0.55371-0.23775 0.62449 0 0.36482-0.54528 0.13346-0.82983-0.35209-0.10743-0.18331-0.35991-0.73516-0.56108-1.2263-0.67272-1.6426-1.1323-2.3729-1.8259-2.9019-0.8058-0.61453-1.4706-0.81429-2.7213-0.81769-1.1544-3e-3 -1.7788 0.12642-2.634 0.54643-1.1937 0.58631-1.8585 1.365-2.8839 3.3781-0.464 0.91092-0.8768 1.4977-1.0536 1.4977-0.03281 0-0.0805-0.13038-0.10599-0.28974-0.08067-0.50448-0.43913-1.1822-0.85694-1.6203-0.70316-0.73719-1.4842-1.0404-2.559-0.99335-0.5698 0.0249-0.71836 0.0609-1.2038 0.29142-1.642 0.77976-2.3601 2.8241-1.5497 4.4119l0.18834 0.36904-1.7068 2e-3c-1.8296 2e-3 -2.6996 0.0807-4.0536 0.36477-2.0882 0.43817-3.7668 1.2284-5.1244 2.4124l-0.50683 0.44202-0.09004-0.57954c-0.24108-1.5518-0.21859-2.9886 0.07421-4.7398 0.31856-1.9052 1.0472-4.3646 1.8465-6.2327 0.49541-1.1578 1.5026-3.104 2.0853-4.0295 0.55959-0.88877 0.54471-0.78721 0.36676-2.503-0.257-2.478-0.25953-5.7303-0.0059-7.53 0.29391-2.0852 0.86367-3.4725 1.6639-4.0513 0.29403-0.21268 0.34196-0.22376 0.96006-0.22195 0.57207 2e-3 0.715 0.0295 1.1846 0.23062 1.7374 0.74415 4.0583 2.6088 6.2302 5.0053 1.6764 1.8498 1.5816 1.7672 2.0262 1.7661 0.21093-5e-4 0.59153-0.0661 0.84576-0.14584 1.2684-0.39769 3.7922-0.97154 5.3336-1.2128 1.3174-0.20615 2.9857-0.22169 3.9759-0.037 1.4419 0.26887 3.1979 0.80218 4.9166 1.4932 0.90255 0.36287 1.3237 0.41547 1.6435 0.20523 0.10379-0.0682 0.51943-0.5241 0.92363-1.013 0.94044-1.1375 2.8688-3.0699 3.8302-3.8381 1.4486-1.1575 2.6783-1.8403 3.6872-2.0472 1.0814-0.22182 1.5574 0.025 2.0756 1.0766 0.85675 1.7384 1.2272 4.5555 1.1981 9.1112l-0.0159 2.489 0.75484 1.9201c1.6959 4.314 2.432 6.6152 2.8367 8.868 0.21097 1.1745 0.23258 3.7097 0.04048 4.7506-0.13793 0.74739-0.53695 2.4046-0.61152 2.5397-0.03024 0.0548-0.11704-0.0229-0.2383-0.21334z",
    fill: "#5f5",
    stroke: "#5f5",
    strokeLinecap: "round",
    strokeWidth: 0.27372
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-3.1594e-5 -55.178)",
    d: "m75.684 255.41c-0.80158-0.17138-0.90858-0.35332-0.89977-1.5298 0.0082-1.0905 0.21002-2.1584 0.70131-3.7104l0.18402-0.58131 0.67379-0.36323c1.6279-0.87758 3.0541-2.0394 3.6989-3.0132 0.22286-0.33657 0.27436-0.47849 0.27436-0.7561 0-0.58468-0.41742-0.99779-1.0087-0.9983-0.41918-3.6e-4 -0.67405 0.1497-0.99778 0.58751-0.85745 1.1596-2.5312 2.2723-4.7149 3.1344-0.92239 0.36415-3.0329 1.0109-3.0953 0.94857-0.02211-0.0221 0.01038-0.48218 0.07219-1.0224s0.09246-1.0621 0.0681-1.1597c-0.16174-0.6482-0.86337-0.96338-1.4864-0.66772-0.39625 0.18804-0.51008 0.45994-0.63304 1.5121-0.29842 2.5536-0.84317 5.6499-1.2134 6.8965l-0.10407 0.35044-0.79435-0.35446c-2.3379-1.0432-4.7885-1.5625-6.8498-1.4516-0.82753 0.0445-1.9963 0.23588-2.4048 0.39373-0.11011 0.0425-0.22856 0.0773-0.26322 0.0773-0.0691 0-0.0495-0.46762 0.117-2.7919 0.10801-1.5077 0.10731-1.5542-0.02721-1.8134-0.21476-0.41394-0.45404-0.51181-1.4522-0.59401-1.0953-0.0902-3.3059-0.11732-3.5433-0.0435-0.09778 0.0304-0.31278 0.2273-0.47778 0.43754l-0.29998 0.38224 0.31776 2.497c0.17477 1.3734 0.31776 2.5227 0.31776 2.5541 0 0.0314-0.40802-0.0486-0.90672-0.17792-0.4987-0.12928-1.4028-0.32269-2.009-0.42979-1.009-0.17824-1.2558-0.19475-2.9157-0.19498-1.6275-2.1e-4 -1.8898 0.0165-2.5582 0.16284-0.963 0.21091-1.4655 0.3798-2.1956 0.73796-0.48462 0.23773-0.60531 0.27286-0.65761 0.19139-0.15566-0.24247-0.73004-1.3928-1.1684-2.3399-1.368-2.956-2.4117-5.9433-2.7285-7.8099-0.42885-2.5266-0.60349-6.8303-0.45862-11.302l0.04664-1.4394 0.35511 0.20502c0.34662 0.20012 0.3592 0.21922 0.52638 0.79941 0.99065 3.438 2.7758 6.5952 4.9605 8.7732 2.4073 2.3999 5.2126 3.7964 8.7468 4.3542 0.9833 0.1552 4.2007 0.17552 5.1943 0.0328 4.4049-0.63267 7.5005-2.3474 9.8463-5.4543 0.64744-0.85748 1.0489-1.5321 1.6367-2.7504 0.73703-1.5276 1.2145-3.049 1.8151-5.7834 0.01883-0.0857 0.19441-0.22696 0.44212-0.35558 1.9358-1.0052 4.3282-3.0172 5.7077-4.8003 1.7381-2.2466 3.0867-4.9519 3.939-7.9015 0.65729-2.2748 0.89888-3.7524 0.89888-5.4976v-1.0889l0.22169-0.27646c0.77932-0.97184 1.6567-2.5176 2.0838-3.6716 0.50785-1.3718 0.65967-2.3224 0.86049-5.3876 0.31487-4.8061 0.70604-6.2972 1.9436-7.4088 0.96903-0.87038 2.0591-0.67031 3.4238 0.62842 1.8675 1.7772 2.9718 4.049 3.5896 7.3848 0.3349 1.8083 0.42121 2.8928 0.42449 5.3336 0.0034 2.569-0.02923 2.8182-0.60674 4.6269-0.70601 2.2111-1.7045 4.3906-3.3192 7.2455l-0.60117 1.0628 0.14641 0.60836c0.35887 1.4912 0.5084 2.7821 0.55801 4.8171 0.04687 1.9226-0.03164 3.1736-0.29864 4.7588-0.44919 2.6669-1.3413 5.1625-2.6087 7.2972-0.32701 0.5508-0.33361 0.61958-0.1965 2.0475 0.11655 1.2138 0.1197 3.9992 0.0056 4.9781-0.21346 1.8317-0.61131 3.2712-1.2874 4.658-0.49245 1.0101-1.5799 2.6616-1.9258 2.9246-0.62114 0.47233-2.132 1.0307-3.638 1.3446-0.95844 0.19976-2.8826 0.29807-3.4519 0.17635z",
    fill: "#0a0",
    stroke: "#0a0",
    strokeLinecap: "round",
    strokeWidth: 0.14223
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-3.1594e-5 -55.178)",
    d: "m51.596 245.87c-3.9951-0.32704-7.8343-2.3681-10.446-5.5538-1.6358-1.9951-3.1276-4.8765-3.9177-7.567l-0.16606-0.56551h0.27057c0.31576 0 0.6861-0.17895 0.87234-0.42153 0.13826-0.18007 0.18226-0.84601 0.07446-1.1269-0.03499-0.0912-0.54994-0.48952-1.1443-0.88523-3.2722-2.1784-5.6483-5.9581-6.9335-11.029-0.20246-0.79883-0.3681-1.5612-0.3681-1.6942 0-0.54251 2.2639-2.0263 3.9847-2.6116 1.5608-0.53087 2.5262-0.67221 4.9757-0.72848l2.3358-0.0537 0.32275 0.36759c0.17751 0.20217 0.58056 0.51041 0.89567 0.68496 0.51522 0.28541 0.67057 0.31738 1.5424 0.31738 0.8718 0 1.0272-0.032 1.5424-0.31738 1.0066-0.55762 1.6175-1.4699 1.7167-2.5636 0.04514-0.4978 0.11955-0.69674 0.34539-0.92338 0.15832-0.15888 0.47322-0.62818 0.69977-1.0429 1.2363-2.2632 1.9202-3.059 3.1046-3.6133 1.6518-0.77298 3.71-0.70243 4.988 0.17097 0.65943 0.45067 1.1048 1.0476 1.6199 2.1709 0.98708 2.153 1.1179 2.3845 1.424 2.52 0.28416 0.12579 0.30357 0.17632 0.31327 0.81574 0.01956 1.2901 0.8677 2.5023 2.0677 2.9553 0.78155 0.295 1.99 0.24748 2.6758-0.10523 0.6741-0.34669 1.2439-0.96862 1.5384-1.679l0.2585-0.62367 1.0786 0.0716c3.9489 0.26217 6.6885 1.4577 9.023 3.9376 1.2794 1.359 1.259 1.2988 0.84318 2.4896-1.619 4.6363-4.2151 8.016-7.7772 10.125-1.1683 0.69157-1.3285 0.85982-1.3285 1.3951 0 0.51239 0.35758 0.93422 0.87406 1.0311 0.21107 0.0396 0.35978 0.13193 0.35978 0.22338 0 0.31313-0.64907 2.7156-1.027 3.8014-2.2245 6.3908-7.0989 9.9115-13.945 10.073-0.91828 0.0216-2.1301 2e-3 -2.6929-0.0445zm6.2541-26.829c0.92338-0.17512 1.3147-0.71301 1.0663-1.4656-0.17581-0.53269-0.5833-0.71049-1.4296-0.62378-0.57538 0.059-0.75036 0.0332-1.1459-0.16861-0.65643-0.33489-1.4373-1.0977-1.9424-1.8974-0.45668-0.7231-0.68296-0.90601-1.1208-0.90601-0.52338 0-0.82894 0.23901-1.1636 0.91019-0.3858 0.77368-0.84409 1.2856-1.4337 1.6016-0.35988 0.19287-0.61428 0.23125-1.5441 0.23293-1.0851 2e-3 -1.1198 0.01-1.3734 0.30423-0.36694 0.42635-0.34673 0.94394 0.05438 1.3926 0.37687 0.56497 1.0265 0.35178 1.6427 0.35178 1.2695 0 1.3602-0.0152 2.0524-0.34308 0.39832-0.18869 0.9666-0.5698 1.2629-0.84691l0.53865-0.50384 0.70672 0.64758c0.7354 0.67386 1.6206 1.1654 2.365 1.3133 0.62098 0.12337 0.81852 0.1235 1.4646 9.7e-4z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.34742
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-3.1594e-5 -55.178)",
    d: "m48.634 260.82c-1.6609-0.18899-3.8819-1.0462-4.9995-1.9296-0.6584-0.52044-1.5921-1.7457-2.3817-3.1255-0.64531-1.1276-0.68765-1.0157 0.56947-1.505 1.5314-0.59594 2.0508-0.66675 4.5496-0.62011 2.0874 0.039 2.3843 0.0699 3.8464 0.40017l1.5844 0.35796 0.07778 0.49724c0.04278 0.27348 0.07966 1.2728 0.08196 2.2207 0.0045 1.8526-0.14007 2.6455-0.58557 3.2119-0.35197 0.44745-1.4325 0.64138-2.7429 0.49227z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-3.1594e-5 -55.178)",
    d: "m58.05 260.77c-0.77168-0.32065-1.0542-1.4942-1.1421-4.7447l-0.06162-2.2772 0.79492-0.186c2.4363-0.57006 5.415-0.19959 8.4189 1.0471l1.0695 0.44386-0.05593 0.34464c-0.03076 0.18955-0.2141 0.72677-0.40742 1.1938-0.28317 0.68413-0.48908 0.98527-1.0593 1.5493-1.8861 1.8656-5.9727 3.2874-7.5569 2.6291z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.66901 0 0 .66901 125.99 -2.0612)",
    filter: "url(#filter12129)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99798 1.7286 -1.7286 .99798 345.29 -306.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.77,
    y: 166.17,
    width: 49.135,
    height: 74.135,
    ry: 8.1835,
    fill: "#fff",
    style: {
      paintOrder: "normal"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#pattern83661-7)",
    strokeWidth: 0.68529
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 147.15)",
    stroke: "#f80000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.10886 0 0 .10886 -401.02 80.325)",
    fill: "url(#pattern83661-7)",
    stroke: "#f80000",
    strokeWidth: 6.2953
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-310.39 52.306c-37.115 9.5866-48.126-33.742-50.252-71.448-2.0063-35.594 35.683-121.49 103.85-119.38 68.164 2.1064 117.69 36.271 160.78 35.209 43.611-1.0747 72.653-19.517 89.898-35.164 11.477-10.415 24.511-17.215 41.509-1.3756 16.194 15.089 27.53 37.755 12.658 83.055-7.9699 24.279-47.172 101.33-137.81 92.383-89.634-8.8432-80.337-24.819-116.79-25.32-27.354-0.37641-40.312 3.357-64.086 18.839-10.471 6.8184-21.226 19.203-39.76 23.204z",
    fill: "url(#pattern88495-2)",
    stroke: "#f80000",
    strokeWidth: 6.2953
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 167.15)",
    stroke: "#f00"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.10886 0 0 .10886 -401.02 80.325)",
    fill: "url(#pattern83661-7)",
    stroke: "#f00",
    strokeWidth: 6.2953
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-310.39 52.306c-37.115 9.5866-48.126-33.742-50.252-71.448-2.0063-35.594 35.683-121.49 103.85-119.38 68.164 2.1064 117.69 36.271 160.78 35.209 43.611-1.0747 72.653-19.517 89.898-35.164 11.477-10.415 24.511-17.215 41.509-1.3756 16.194 15.089 27.53 37.755 12.658 83.055-7.9699 24.279-47.172 101.33-137.81 92.383-89.634-8.8432-80.337-24.819-116.79-25.32-27.354-0.37641-40.312 3.357-64.086 18.839-10.471 6.8184-21.226 19.203-39.76 23.204z",
    fill: "url(#pattern88495-2)",
    stroke: "#f00",
    strokeWidth: 6.2953
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 127.15)",
    stroke: "#f00"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.10886 0 0 .10886 -401.02 80.325)",
    fill: "url(#pattern83661-7)",
    stroke: "#f00",
    strokeWidth: 6.2953
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-310.39 52.306c-37.115 9.5866-48.126-33.742-50.252-71.448-2.0063-35.594 35.683-121.49 103.85-119.38 68.164 2.1064 117.69 36.271 160.78 35.209 43.611-1.0747 72.653-19.517 89.898-35.164 11.477-10.415 24.511-17.215 41.509-1.3756 16.194 15.089 27.53 37.755 12.658 83.055-7.9699 24.279-47.172 101.33-137.81 92.383-89.634-8.8432-80.337-24.819-116.79-25.32-27.354-0.37641-40.312 3.357-64.086 18.839-10.471 6.8184-21.226 19.203-39.76 23.204z",
    fill: "url(#pattern88495-2)",
    stroke: "#f00",
    strokeWidth: 6.2953
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2467 0 0 1.2467 -170.59 -173.84)",
    filter: "url(#filter5185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m253.12 252.72c-1.2787-1.2848-3.0236-2.3723-3.8208-2.3814-0.20333-2e-3 0.0744-0.18688 0.61711-0.41016 0.54274-0.22327 1.2698-0.62184 1.6158-0.88571 1.5868-1.2103 2.7154-4.0645 2.078-5.2554-0.13882-0.25939-0.12559-0.3421 0.0548-0.3421 0.46162 0 3.141 0.73607 4.2363 1.1638 1.008 0.39362 3.3218 1.8007 3.3189 2.0183-6.7e-4 0.0494-0.29685 0.28881-0.65818 0.53199-1.2395 0.8342-4.0112 3.7998-5.0002 5.3499-0.535 0.83858-1.0125 1.5212-1.0612 1.5169-0.0486-4e-3 -0.66989-0.59203-1.3806-1.3061z",
    fill: "#fff",
    fillOpacity: 0.99609,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m267.8 249.8s7.5321-3.2279 9.7354-1.5909 1.5372 9.1304 1.5372 9.1304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.87 275.39c2.439 0.16689 8.2261 1.6168 8.8196-0.1888 0.65046-3.1336-3.1328-9.5571-6.1234-10.963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.61 241.94s10.896-0.56153 15.185 4.7222m-16.486 33.01s5.0563 4.7396 11.72 4.9367c6.6947 0.19801 12.025-0.34876 12.355 2.9536 0.19962 1.9973-0.99953 3.975-5.8825 5.9924-4.3365 1.7917-15.206 3.9564-28.773-3.2499-25.028-18.529-9.4691-48.342 11.882-48.365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.53 251.03s3.3394-0.34946 5.5915 1.3629 3.5236 3.8284 3.5236 3.8284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.82 284.32s-13.439-11.203-5.1748-28.096 27.361-12.127 29.401-11.053 12.242 3.9444 12.521 19.062"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m295.83 275.7s-3.2802 10.048-11.678 13.086c-8.3973 3.038-13.658 0.30057-13.658 0.30057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.52 275.56s0.0835 1.0842 0.84689 2.3939c0.76339 1.3096 1.2751 1.604 1.2751 1.604",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.34 285.66s0.65167 0.3951 1.5983 0.51857 1.5572-6e-3 1.5572-6e-3",
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.23979
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.69 266.92c-2.0038-0.15205-3.7149-0.6753-4.6545-1.4233l-0.0842-0.067 0.0419-0.40938c0.62332-6.0974 3.7198-12.001 8.4964-16.198 3.7117-3.2613 8.2309-5.2625 12.994-5.754 0.92389-0.0953 3.082-0.14498 4.2118-0.0969 1.3336 0.0567 3.2826 0.24422 3.4455 0.33142 0.17874 0.0957 0.4301 0.54089 0.51975 0.92066 0.0803 0.34013 0.0478 0.986-0.0726 1.4428-0.59563 2.2601-2.2358 3.9009-4.4769 4.4788-0.38564 0.0994-0.41361 0.10187-0.63546 0.0554-0.68191-0.14286-1.0865-0.17661-2.1319-0.1778-1.0108-1e-3 -1.0446 1e-3 -1.2226 0.0817-0.3776 0.17092-0.59814 0.52032-0.59814 0.94764 0 0.39134 0.18236 0.68221 0.56993 0.90904 0.0644 0.0377 0.0679 0.0988 0.0679 1.1829 0 1.2036-0.0257 1.5418-0.1837 2.4157-0.25811 1.4277-0.68831 2.5476-1.5312 3.9861-0.84662 1.4448-1.5652 2.3965-2.5674 3.4002-0.91423 0.91569-1.664 1.4817-2.748 2.0744-1.8288 0.99996-4.4285 1.7146-6.9135 1.9003-0.56806 0.0425-1.9619 0.0419-2.5271-9.7e-4z",
    fill: "#f55",
    stroke: "#fb5454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.96 264.69c-1.7608-0.0672-4.0164-0.34445-5.5373-0.68053-2.1458-0.47419-3.9969-1.3264-5.5578-2.5588-0.43541-0.34375-1.5429-1.4418-1.5836-1.5701-0.0303-0.0956 0.32029-1.0538 0.73984-2.0216 3.1404-7.2446 8.5827-11.57 16.08-12.781 1.4006-0.22618 2.53-0.31052 4.161-0.31074 2.1544-3e-4 3.9782 0.18507 5.919 0.60161 1.1063 0.23743 1.8528 0.47073 2.6208 0.81903 0.38263 0.17353 0.98284 0.44524 1.3338 0.60379 0.76729 0.34664 1.4048 0.67841 2.1094 1.0977l0.52445 0.3121 0.0818 0.24861c0.24007 0.7294 0.37082 1.5098 0.40076 2.3921 0.0749 2.2066-0.59883 4.223-2.1315 6.3795-1.8106 2.5476-4.45 4.3301-8.7042 5.8781-2.2418 0.81575-4.2334 1.2691-6.5459 1.4899-0.63043 0.0602-2.5143 0.14932-2.9024 0.13729-0.1019-3e-3 -0.55579-0.0199-1.0086-0.0372zm12.463-6.4014c0.22976-0.0783 0.46896-0.30201 0.57202-0.53499 0.1145-0.25883 0.16956-1.1754 0.17052-2.8382 1e-3 -1.838-0.0854-2.9486-0.32306-4.1512-0.45537-2.3039-1.3133-3.4908-2.8077-3.8847-0.3392-0.0894-0.51818-0.1086-1.1722-0.12582-1.3545-0.0357-2.6468 0.17012-4.5768 0.72875-1.4724 0.42618-3.8477 1.2939-4.1287 1.5082-0.0736 0.0561-0.18515 0.18942-0.24792 0.29621-0.0977 0.16611-0.11402 0.23876-0.11332 0.50292 8.8e-4 0.33281 0.0616 0.49877 0.26119 0.71394 0.19231 0.20732 0.40508 0.29246 0.72606 0.29054 0.26071-2e-3 0.36275-0.0315 1.0704-0.31396 2.7871-1.1126 5.5414-1.7839 6.9988-1.7059 0.92577 0.0496 1.1742 0.19735 1.5335 0.91242 0.59242 1.1788 0.87251 3.9297 0.70534 6.9276-0.057 1.0219-0.0376 1.1244 0.27016 1.4316 0.30048 0.29984 0.65553 0.38094 1.0618 0.24253z",
    fill: "#faa",
    stroke: "#faa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285 286.99c0.19035-2.7074 0.56721-4.9023 1.2126-7.0618 0.57637-1.9287 1.7856-4.7638 3.4562-8.1031 2.129-4.2557 4.0732-7.358 5.4757-8.7374l0.34605-0.34036 0.0241 0.39798c0.0133 0.21889 0.0262 0.58069 0.0288 0.804 8e-3 0.68849 0.15548 0.97736 0.62606 1.2261 0.31285 0.16537 0.6491 0.38953 0.91533 0.61018 2.0005 1.6581 4.0017 5.0014 4.556 7.6117 0.0484 0.22792 0.0699 0.50006 0.0713 0.90101l2e-3 0.57445-0.22842 0.0698c-0.38785 0.11846-1.0817 0.15946-1.8623 0.11005-0.88655-0.0561-1.3582-0.11101-3.3261-0.38703-2.4975-0.35031-2.587-0.35449-2.9556-0.13844-0.32908 0.19286-0.50828 0.5499-0.47274 0.94189 0.0255 0.28119 0.13418 0.49195 0.353 0.68456 0.19881 0.175 0.36207 0.22849 0.83938 0.275 0.18588 0.0181 0.34714 0.0421 0.35836 0.0533 0.0337 0.0337-0.57675 1.3428-0.96628 2.0723-2.182 4.0865-4.9683 7.0278-8.1957 8.6516l-0.28281 0.14228z",
    fill: "#f00",
    stroke: "#f00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m241.37 291.75c-1.5101-0.58358-3.4986-1.4768-4.6145-2.0727-1.0313-0.55079-2.9526-2.1457-4.7433-3.9377-1.9269-1.9282-3.4241-3.8376-4.7138-6.0117-0.7327-1.2351-1.5722-3.0243-2.0279-4.3219-0.21409-0.60962-0.20914-0.66957 0.0859-1.0408 0.35855-0.45118 0.89652-0.68257 2.018-0.86799 1.0728-0.17737 1.8396-0.22434 3.1835-0.19502 3.2407 0.0707 5.0918 0.73867 7.1071 2.5646 1.6364 1.4827 3.3336 4.3283 4.0027 6.7112 0.71441 2.5442 0.90654 6.0776 0.48265 8.8762-0.0454 0.29981-0.097 0.54414-0.11456 0.54296-0.0176-1e-3 -0.31722-0.11237-0.66584-0.2471z",
    fill: "#ff2a2a",
    stroke: "#ff2a2a",
    strokeWidth: 0.1199
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m250.08 293.92c-2.1049-0.2839-4.8052-0.90863-6.6323-1.5344l-1.238-0.42403 0.0884-0.86703c0.16224-1.5907 0.0681-5.4492-0.16571-6.7918-0.72037-4.1368-3.3944-8.3143-6.3097-9.8574-1.6564-0.87675-3.0083-1.159-5.6395-1.1775-2.5796-0.0181-3.9029 0.23299-4.6818 0.88834l-0.50486 0.42481-0.36308-1.5503c-0.67365-2.8764-0.95928-7.291-0.46356-7.1648 0.0973 0.0248 0.77376 0.25757 1.5033 0.51736 1.1193 0.39857 1.6995 0.48427 3.7147 0.54866 3.6197 0.11566 6.8223-0.62139 9.3306-2.1474 1.1957-0.72741 3.1409-2.6431 4.036-3.9748 1.6332-2.4298 2.3109-4.3536 2.4948-7.0827l0.1118-1.6591 1.4309 0.0931c2.2606 0.14715 3.2448 0.61241 4.9924 2.3601 0.81343 0.81343 1.479 1.5915 1.479 1.729s-0.2799 0.97482-0.622 1.8606c-1.1351 2.9391-1.5239 4.8904-1.6279 8.1694-0.0715 2.2552-0.026 3.3289 0.19637 4.6336 0.69404 4.0717 2.5748 8.1512 5.296 11.488 0.97791 1.199 0.91782 1.2274-1.4134 0.66853-2.417-0.57949-5.0305-1.8756-7.2943-3.6176-1.5084-1.1607-2.4934-1.0849-2.4934 0.19195 0 0.36767 0.14425 0.71443 0.39793 0.95655 0.81104 0.77408 2.9212 2.1667 4.4657 2.9471 3.3752 1.7054 5.4364 2.1055 11.584 2.2486 4.2618 0.0992 5.9509 0.31506 6.7957 0.86863 1.6099 1.0549 0.60534 3.19-2.253 4.7885-4.2356 2.3687-10.206 3.2768-16.215 2.4662z",
    fill: "#fff",
    fillOpacity: 0.99866,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.41724,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.67 288.91c-2.0844-0.44293-2.191-0.49969-2.191-1.1666 0-0.33983-0.12318-0.91268-0.27373-1.273-0.81591-1.9528-2.6441-2.6283-7.5966-2.807-3.4612-0.12488-3.1196 0.0327-5.1228-2.3629-4.72-5.6448-6.442-12.566-4.7828-19.225l0.49373-1.9815 1.0803 0.96553c2.8128 2.514 6.8365 3.664 12.842 3.6702 3.4778 4e-3 5.5429-0.30969 8.5072-1.2905 5.9882-1.9814 9.6526-4.9857 11.168-9.156 0.43615-1.2006 0.62264-4.0336 0.33428-5.078-0.1051-0.38062-0.17197-0.71115-0.14862-0.7345 0.1331-0.1331 2.4819 1.9856 3.359 3.03 1.1505 1.3698 2.5805 4.067 3.1189 5.8824 0.39199 1.3218 0.8982 4.0518 0.8982 4.844 0 0.3469-0.22001 0.75185-0.68406 1.2591-1.505 1.645-3.4704 4.962-5.7748 9.7462-2.441 5.0678-3.3871 8.051-3.8107 12.016l-0.21631 2.0245-0.62059 0.29594c-0.34132 0.16276-1.5435 0.54038-2.6716 0.83915-1.7466 0.4626-2.4315 0.55163-4.6154 0.6-1.4105 0.0312-2.8917-0.0127-3.2917-0.0977zm5.5909-1.9499c0.80214-0.80215 0.0472-2.017-1.1343-1.8253-0.32317 0.0524-1.0282-0.0327-1.5667-0.18929-1.7131-0.498-2.2511-0.33164-2.2511 0.69606 0 1.0364 1.2117 1.6094 3.493 1.6517 0.88729 0.0165 1.1752-0.0493 1.4591-0.3332zm-11.771-6.76c0.40927-0.58432 0.33998-0.94873-0.32032-1.6845-0.69521-0.77469-1.2308-1.7757-1.5152-2.8317-0.2537-0.94218-0.82462-1.3663-1.4957-1.1112-0.92632 0.35218-0.90215 1.62 0.0675 3.5409 0.79778 1.5804 1.6681 2.4796 2.4 2.4796 0.40755 0 0.67303-0.12082 0.86373-0.39308z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.27097,
    style: {
      paintOrder: "normal"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93826 0 0 .93826 -3.4716 80.545)",
    filter: "url(#filter6631)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.15691 0 0 .15691 245.03 52.467)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0036488 -1.0849 1.0849 .0036488 269.24 36.123)",
    fill: "#0a0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.3367 0 0 7.3367 -1371 -1543.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.77,
    y: 166.17,
    width: 49.135,
    height: 74.135,
    ry: 8.1835,
    fill: "#fff",
    style: {
      paintOrder: "normal"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#pattern83661-4)",
    strokeWidth: 0.68529
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 147.15)",
    stroke: "#f80000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 167.15)",
    stroke: "#f00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75297 0 0 .75297 471.16 127.15)",
    stroke: "#f00"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1.1201 1.1201 0 177.84 10.907)",
    stroke: "#892ca0",
    strokeWidth: 8.9278
  }, /*#__PURE__*/React.createElement("rect", {
    x: -369.88,
    y: -148.53,
    width: 263.11,
    height: 124.55,
    rx: 63.076,
    ry: 62.275,
    fill: "none",
    stroke: "#892ca0",
    strokeWidth: 8.9278
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1.1201 1.1201 0 437.84 10.907)",
    stroke: "#892ca0",
    strokeWidth: 8.9278
  }, /*#__PURE__*/React.createElement("rect", {
    x: -369.88,
    y: -148.53,
    width: 263.11,
    height: 124.55,
    rx: 63.076,
    ry: 62.275,
    fill: "none",
    stroke: "#892ca0",
    strokeWidth: 8.9278
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.83783 0 0 .83783 50.946 -29.163)",
    filter: "url(#filter4164)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.82,
    cy: 165.56,
    rx: 8.9862,
    ry: 6.2011,
    fill: "#fff",
    stroke: "#fffffd",
    strokeLinecap: "round",
    strokeWidth: 0.35492
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.19 76.247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-88.674 72.868c-1.4689-0.50036-2.2625-1.7263-2.491-3.8482-0.0808-0.75083-0.0441-1.3759 0.134-2.2785 0.0824-0.41774 0.15995-0.65115 0.2383-0.71748 0.18151-0.15364 2.3056-0.83511 3.1302-1.0042l0.743-0.1524 0.13829 0.26712c0.46995 0.90771 0.81902 2.6747 0.81898 4.1456-4e-5 1.5966-0.30738 2.701-0.92201 3.3129-0.46564 0.4636-0.99678 0.54526-1.7898 0.27515z",
    fill: "#80a",
    stroke: "#7a0099",
    strokeLinecap: "round",
    strokeWidth: 0.31675
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233.36 -76.522)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.56,
    cy: 161.07,
    rx: 3.1789,
    ry: 3.1178
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.86,
    cy: 161.21,
    rx: 3.1789,
    ry: 3.1178
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.92 193.29c2.1208-4.9373 11.043-9.8897 13.581-11.077 3.1028-1.4512 11.827-4.3096 14.931 0.91534 2.7657 4.6549-6.0707 9.8756-9.7999 10.912-3.0325 0.84248-16.073 3.289-18.712-0.75027z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.33 182.41c-12.193-2.5422-14.125-16.347-13.522-21.787 0.57429-5.1802 1.1992-7.0322 3.8453-11.288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.92 142.12c5.0416-2.4001 9.1054-2.5029 15.417-0.60573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.66 149.33s-2.2478-10.835 1.5874-13.715c3.8352-2.8801 11.671 6.503 11.671 6.503"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m156.33 141.51s5.9306-6.7202 9.8038-6.4573c3.8733 0.26286 4.5209 11.943 3.505 13.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.76 179.28c12.204-7.223 12.166-20.149 5.8798-30.344",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.97 180.33c-0.13969 0.50287 2.451 12.697 16.839 14s14.375 0.20573 19.296-0.70859"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.64 148.93s10.959-3.4172 17.779 0.36572c6.8195 3.783 10.217 11.75 11.328 17.006 0.95503 4.5204 0.29208 10.869-1.943 15.235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.32 166.85s3.9804 0.61933 4.6608-3.5893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.52 166.9c-2.5572 0.0282-4.2307-1.4357-4.5357-3.6456"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.31675
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m232.34 230.75c-0.52794-0.74583-0.9961-1.5139-1.2998-2.1325-0.18959-0.38613-0.19766-0.4273-0.11537-0.58821 0.0487-0.0952 0.39535-0.48129 0.77041-0.85807 1.0407-1.0454 2.2947-1.8326 3.4022-2.1354 1.4392-0.39355 3.006 0.25565 3.0068 1.2458 1e-3 1.6167-2.4389 4.3207-4.4578 4.9398-0.84388 0.25875-0.77095 0.28507-1.3064-0.47139z",
    fill: "#892ca0",
    stroke: "#882c9f"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m229.6 224.81c-0.15487-0.0432-0.47981-1.2541-0.76503-2.851l-0.15021-0.84095 0.22794-0.25446c0.56817-0.63426 1.3461-1.1167 2.3752-1.473 0.5418-0.18757 0.64282-0.20239 1.3903-0.20391 0.78692-2e-3 0.81577 3e-3 1.218 0.20109 1.0999 0.54119 1.506 1.6129 1.0026 2.6452-0.53841 1.104-2.2256 2.2475-3.8763 2.6272-0.54171 0.12459-1.2465 0.19878-1.4225 0.14973z",
    fill: "#892ca0",
    stroke: "#7f2995"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m255.6 204.6c-0.85602-0.34735-1.4546-1.0773-1.8239-2.2241-0.2155-0.66931-0.28292-1.1653-0.28195-2.0742 1e-3 -1.2308 0.20828-2.2132 0.6881-3.2661 0.20843-0.45739 0.22823-0.47985 0.42297-0.47985 0.43059 0 2.1425 0.33459 3.66 0.71536l0.44515 0.1117 0.0502 0.40686c0.0276 0.22377 0.0485 0.90839 0.0463 1.5214-3e-3 0.90397-0.0295 1.2336-0.13971 1.7453-0.27903 1.2956-0.78878 2.4444-1.3568 3.058-0.55751 0.60218-1.0668 0.74676-1.7104 0.48561z",
    fill: "#660080",
    stroke: "#61007a"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m272.34 222.77c-1.1517-0.29461-2.136-0.9152-2.601-1.6399-0.38958-0.60712-0.55354-1.5794-0.34736-2.0598 0.20033-0.46687 0.72642-0.80922 1.5553-1.0121 0.52948-0.12961 1.9872-0.14553 2.7243-0.0298 0.70914 0.11138 1.8641 0.40615 2.3439 0.59824l0.41138 0.16469v0.29982c0 0.58539-0.27641 2.3413-0.49825 3.1651-0.0563 0.20907-0.0926 0.23795-0.44799 0.35621-1.0516 0.34996-2.1689 0.406-3.1402 0.15752z",
    fill: "#ab37c8",
    stroke: "#ab37c8"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m270.57 229.96c-0.78869-0.17391-1.399-0.48023-2.2454-1.127-0.65715-0.50213-1.2151-1.1334-1.4858-1.6808-0.21581-0.43653-0.23145-0.50606-0.23145-1.0288 0-0.46326 0.0253-0.61189 0.14544-0.85594 0.54536-1.1075 2.7225-1.2703 4.9619-0.37103 0.92661 0.37211 1.93 1.0562 2.2893 1.5608l0.12445 0.17477-0.48878 0.73469c-0.52476 0.78878-1.1681 1.6119-1.7767 2.2734-0.35954 0.39075-0.39256 0.41141-0.65013 0.40674-0.14924-3e-3 -0.43852-0.0418-0.64285-0.0868z",
    fill: "#bc5fd3",
    stroke: "#bc5fd3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m282.29 215.93c-0.95442-0.15958-1.6303-0.89422-1.84-2-0.0828-0.4366-0.07-1.4895 0.0295-2.4302 0.0654-0.61814 0.18992-1.2004 0.52308-2.4457 0.66753-2.4951 0.91483-3.8815 0.86575-4.8534l-0.0235-0.46501 1.1157 6.4e-4c1.5672 9e-4 3.4583 0.1896 4.3818 0.43721l0.23219 0.0623-1e-3 0.66321c-1e-3 0.804-0.16471 1.9061-0.65792 4.4384-0.2594 1.3319-0.73595 2.8021-1.2649 3.9024-0.93889 1.953-2.1191 2.8977-3.3606 2.6902z",
    fill: "#80a",
    stroke: "#80a"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m289.47 220.44c-0.34443-0.0912-0.73768-0.49852-0.89632-0.92843-0.17399-0.47151-0.27989-1.3867-0.23124-1.9984 0.10326-1.2984 0.27998-2.0637 0.8681-3.7595 0.47172-1.3602 0.81474-2.526 1.1503-3.9095 0.27388-1.1292 0.80264-3.7132 0.80315-3.9249 1.9e-4 -0.0766 0.0321-0.13931 0.0708-0.13931 0.10905 0 1.059 0.64914 1.7512 1.1967 0.76576 0.60574 2.3135 2.1522 2.9716 2.969l0.48785 0.60556-0.0732 0.52298c-0.0402 0.28764-0.15529 0.80921-0.25565 1.1591-0.3701 1.29-1.8195 4.8859-2.2731 5.6396-0.76983 1.279-1.9518 2.2534-3.0942 2.551-0.39875 0.10386-0.92275 0.11044-1.2793 0.0161z",
    fill: "#ab37c8",
    stroke: "#ab37c8"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m296.19 226.98c-1.0966-0.2953-1.6814-1.0201-1.7377-2.1539-0.0376-0.75695 0.084-1.1661 0.58499-1.9682 1.0701-1.7134 2.4936-4.8908 3.3341-7.442l0.38381-1.1649 0.32804 0.66958c0.85826 1.7518 1.6485 3.9202 2.1358 5.8607l0.27563 1.0976-0.15439 0.59422c-0.37207 1.432-1.1963 2.9433-2.0224 3.7081-0.39848 0.36893-0.94881 0.67836-1.4407 0.8101-0.39849 0.10671-1.2706 0.10087-1.6872-0.0113z",
    fill: "#672178",
    stroke: "#672178"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.31675
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m281.94 249.04c-9.8e-4 -2.3493-0.63942-4.5687-1.7321-6.0214-0.20492-0.27243-0.37264-0.51197-0.3727-0.5323-1.1e-4 -0.0379 2.3316-1.5873 3.0076-1.9985 0.20694-0.12587 0.41591-0.21183 0.46438-0.19102 0.0485 0.0208 0.25238 0.22856 0.45313 0.46166 1.8001 2.0902 2.7045 4.4379 2.8059 7.284l0.0356 0.99926-0.1792 0.0371c-0.5692 0.11783-3.7532 0.47199-4.2434 0.47199h-0.23899l-2.1e-4 -0.51081z",
    fill: "#ab37c8",
    stroke: "#aa37c7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m291.12 246.82c-5e-3 -1.1115-0.0316-1.5192-0.13584-2.0925-0.39014-2.146-1.297-3.7402-3.2742-5.756-0.41634-0.42448-0.75032-0.77845-0.74217-0.7866 8e-3 -8e-3 0.3224-0.13843 0.69834-0.28952 0.84274-0.33869 2.0373-0.72998 2.9538-0.96751l0.6922-0.17941 0.33087 0.321c1.2468 1.2096 2.2964 3.1455 2.8262 5.2124 0.11347 0.44271 0.24016 1.077 0.28154 1.4096 0.0977 0.78539 0.0483 2.2509-0.0908 2.6933l-0.10252 0.32599-0.84867 0.42466c-0.78755 0.39408-2.0726 0.93719-2.429 1.0267l-0.15331 0.0385z",
    fill: "#672178",
    stroke: "#672178"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m298.72 243.1c0-1.7851-1.1804-4.6813-2.5864-6.3457-0.17978-0.21284-0.30196-0.38698-0.27149-0.38698 0.0305 0 0.30283 0.0422 0.60526 0.0937 1.4658 0.24984 2.6347 0.86997 3.3512 1.778 0.95735 1.2132 1.0587 2.118 0.38684 3.4542-0.26416 0.52538-0.83972 1.3186-1.2325 1.6987l-0.25295 0.24475z",
    fill: "#ab37c8",
    stroke: "#ab37c8"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ddafe9",
    stroke: "#ddafe9",
    strokeWidth: 0.34856
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m277.23 249.36c-0.41294-0.0658-1.0253-0.19179-1.3608-0.27987-0.6716-0.17631-1.7832-0.6725-1.7832-0.79599 0-0.0431 0.17923-0.34713 0.39829-0.67562 0.72617-1.0889 3.0199-3.3052 4.7938-4.6319l0.35881-0.26836 0.22083 0.27448c1.0497 1.3046 1.8279 3.7867 1.8296 5.8351l5.5e-4 0.68042-1.8536-9e-3c-1.0194-5e-3 -2.1914-0.0632-2.6044-0.12901z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m286.67 247.97c0-2.5298-0.80292-4.7929-2.4509-6.9079l-0.72793-0.93424 0.29896-0.17675c0.66894-0.39547 1.1914-0.67785 2.1243-1.1482l0.98066-0.49445 0.84942 0.88372c1.57 1.6334 2.4433 3.0239 2.9146 4.6408 0.21961 0.75336 0.39602 2.4765 0.41844 4.0872 3e-3 0.22077-0.0455 0.25539-0.48931 0.3484-1.9711 0.41313-3.1777 0.65598-3.5194 0.70837l-0.39887 0.0611z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m294.81 244.92c0.0252-1.4128 5e-3 -1.654-0.20459-2.4758-0.4765-1.866-1.2624-3.4922-2.3338-4.8294-0.34842-0.43485-0.63349-0.80564-0.63349-0.82398 0-0.14474 3.2054-0.45794 3.7672-0.36809 0.33219 0.0531 0.43836 0.1368 0.80451 0.63413 1.331 1.8078 2.2919 4.1938 2.3975 5.9531l0.0356 0.59378-0.59232 0.54275c-0.54522 0.4996-2.1576 1.6745-2.9401 2.1424l-0.32847 0.19641z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m-100.79 69.335c-1.6031-0.0634-1.8886-1.6293-1.8886-1.6293s-0.29999-2.1619 0.1916-3.825c0.42228-1.4287 1.3294-0.75305 2.088-0.43987 0.75855 0.31319 2.3773 1.7911 2.4907 2.7483 0.11339 0.95714 8e-3 1.1989-0.34409 1.8017-0.41056 0.70379-2.5376 1.3442-2.5376 1.3442z",
    fill: "#fffffe",
    stroke: "#fffffe",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-69.097 68.488c1.6031-0.0634 1.8886-1.6293 1.8886-1.6293s0.29999-2.1619-0.1916-3.825c-0.42228-1.4287-1.3294-0.75305-2.088-0.43987-0.75855 0.31319-2.3773 1.7911-2.4907 2.7483-0.11339 0.95714-8e-3 1.1989 0.34409 1.8017 0.41056 0.70379 2.5376 1.3442 2.5376 1.3442z",
    fill: "#fffffe",
    stroke: "#fff",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-103.71 -55.178)",
    d: "m260.89 248.73c-3.2888-0.15145-7.7913-0.53572-9.363-0.79908-5.0269-0.84237-9.2137-3.51-11.818-7.5297-0.56173-0.86712-1.4596-2.5931-1.3868-2.6659 0.0235-0.0235 0.21632 0.0192 0.42852 0.0949 0.21219 0.0757 0.76866 0.23089 1.2366 0.34494 0.66197 0.16135 0.91823 0.18876 1.1546 0.1235 0.72355-0.19978 1.0045-1.1093 0.51206-1.6575-0.18743-0.20867-0.39604-0.30688-0.94131-0.44316-2.9006-0.72494-4.837-1.8047-6.8737-3.8326l-1.1821-1.177 0.50151-0.11563c1.7314-0.3992 3.9487-2.4234 4.6262-4.2233 0.52048-1.3829-0.2886-2.2365-2.1006-2.2162-0.99322 0.0111-2.1477 0.52609-3.3543 1.4962-0.66729 0.5365-1.4755 1.3413-1.616 1.6093-0.0672 0.12808-0.15139-4e-3 -0.44808-0.70051-0.29488-0.69271-0.89232-2.3336-0.89232-2.4508 0-0.015 0.21041-0.0273 0.46759-0.0273 1.4313 0 3.4563-0.95972 4.4699-2.1184 1.0756-1.2295 0.81176-2.702-0.60307-3.3661-1.2029-0.56455-3.3399-0.0211-4.7064 1.1968l-0.48544 0.43267-0.0505-0.37105c-0.0278-0.20407-0.0762-1.1788-0.1076-2.1661-0.0493-1.5505-0.0309-2.0097 0.13561-3.3712 0.47514-3.8859 1.1295-5.8813 2.9003-8.8439 0.93573-1.5655 0.90326-1.4425 0.69959-2.6503-0.46285-2.7448-0.62719-6.3346-0.36867-8.0532 0.40496-2.6921 1.3983-4.2261 2.7366-4.2261 1.9493 0 5.303 2.381 8.8495 6.2827 0.64419 0.70871 0.66441 0.7224 1.0671 0.7224 0.26898 0 0.61021-0.0906 0.98984-0.26269 0.31864-0.14448 0.58783-0.26269 0.5982-0.26269 0.0104 0-0.0411 0.20687-0.11442 0.45971-0.19656 0.67813-0.19087 2.8197 0.01 3.5682 0.35499 1.3262 1.0438 2.2295 2.0519 2.6911 0.65682 0.3007 1.4716 0.32694 1.8338 0.0591 0.39472-0.2919 0.80123-0.88122 0.94837-1.3749 0.47462-1.5923 0.28242-4.3479-0.42465-6.088l-0.2116-0.52077 0.49323-0.0519c0.95329-0.10026 3.3313-0.086 3.5001 0.021 0.0951 0.0603 0.0829 0.14167-0.0642 0.43015-0.0998 0.19568-0.28694 0.70342-0.41579 1.1283-0.21118 0.69634-0.23459 0.91068-0.2374 2.1735-3e-3 1.2894 0.0155 1.4572 0.23104 2.1057 0.40723 1.2255 1.0796 2.0111 1.9584 2.2882 0.61903 0.19512 1.0443 0.0698 1.5797-0.46568 0.47585-0.47585 1.066-1.6753 1.351-2.7461 0.17171-0.64501 0.19846-0.96326 0.20052-2.3859 2e-3 -1.6098 6e-3 -1.6405 0.18022-1.5848 0.67195 0.2149 1.0388 0.27244 1.2855 0.20167 0.17277-0.0496 0.80684-0.60403 1.7699-1.5477 2.6653-2.6118 4.7801-4.1314 6.4791-4.6555 0.75787-0.23379 1.3258-0.23813 1.6951-0.0129 0.91955 0.56067 1.7653 2.7289 2.2281 5.7123 0.16029 1.0333 0.19515 1.6342 0.1996 3.441 5e-3 2.0545-7e-3 2.2289-0.19796 2.8365-0.24326 0.77444-0.22421 0.87787 0.33214 1.8039 1.0148 1.6889 2.0844 4.1038 2.6584 6.0017 0.62581 2.0692 0.90994 3.7898 0.99265 6.011l0.056 1.5045-0.5998-0.21772c-1.2757-0.46305-2.0071-0.5892-3.4549-0.59588-1.6459-8e-3 -2.1797 0.1264-2.7746 0.69637-0.3709 0.35538-0.3777 0.37236-0.3777 0.94279 0 1.4895 0.97295 2.5798 2.802 3.14 0.85503 0.26187 2.1995 0.26361 3.0957 4e-3l0.60015-0.17384-0.0498 0.24912c-0.13815 0.69075-1.433 3.6728-1.5948 3.6728-0.0267 0-0.14713-0.11705-0.26751-0.26011-0.34052-0.40469-1.4385-1.0963-2.2171-1.3966-1.8164-0.70046-3.7505-0.71668-4.5568-0.0382-0.40408 0.34001-0.52638 0.64744-0.52638 1.3231 0 0.46325 0.0494 0.69888 0.21656 1.0332 0.65054 1.3011 2.4858 2.6207 3.9994 2.8757l0.62519 0.10534-0.77875 0.68712c-0.96601 0.85234-2.2066 1.7856-3.2102 2.4148-0.85553 0.53642-1.0824 0.85002-0.99683 1.3776 0.0867 0.53407 0.64077 0.9531 1.1509 0.87033 0.81027-0.13149 4.0884-2.5769 5.5614-4.1487 2.4305-2.5935 4.0243-5.4813 4.8209-8.7351 0.42225-1.7247 0.55114-2.8663 0.54924-4.8649-4e-3 -3.9878-0.91739-7.6854-2.8694-11.613-0.35592-0.7162-0.62097-1.329-0.58902-1.3618 0.1857-0.1904 4.3921-0.85557 6.1657-0.975l0.59105-0.0398-3.5e-4 0.62476c-5.2e-4 0.90829-0.20173 2.019-0.79529 4.39-0.8394 3.3529-0.90187 5.059-0.22648 6.1853 0.37614 0.62721 0.91254 0.95551 1.6591 1.0154 0.61821 0.0496 1.1034-0.10934 1.683-0.55139 0.9111-0.69494 1.943-2.6757 2.5287-4.8543 0.36616-1.3618 0.84765-4.1704 0.90446-5.2757 0.0291-0.56588 0.0661-1.0289 0.0822-1.0289s0.41402 0.12185 0.88416 0.27078c0.75441 0.23897 2.26 0.917 2.528 1.1384 0.0701 0.058 0.0422 0.36526-0.1006 1.1086-0.52334 2.7236-0.92746 4.2619-2.0048 7.6315-0.92837 2.9037-0.87249 5.1631 0.14566 5.8893 0.24327 0.1735 0.39313 0.20439 0.99177 0.20439 0.64097 0 0.76695-0.0305 1.3832-0.33515 0.8141-0.40244 1.6526-1.1572 2.1922-1.9733 0.78165-1.1822 2.3345-5.1351 2.6718-6.8015l0.15044-0.74306 0.44357 0.63587c0.4857 0.69627 1.3255 2.0601 1.6008 2.5999l0.17461 0.34227-0.48538 1.43c-0.81088 2.389-2.1073 5.2889-3.1117 6.9604-0.55518 0.92394-0.68984 1.322-0.68984 2.0392 0 1.0783 0.4386 1.8256 1.3073 2.2275 0.32703 0.15129 0.56818 0.18512 1.3196 0.18512 0.87029 0 0.94905-0.0155 1.4739-0.28948 0.94273-0.49217 1.6061-1.2919 2.3-2.7727 0.18216-0.38873 0.40954-0.98177 0.50529-1.3179 0.0958-0.3361 0.17719-0.57169 0.18097-0.52353 4e-3 0.0482 0.0479 0.34056 0.0981 0.64978 0.35743 2.2029 0.22696 5.6108-0.31846 8.3187-0.30399 1.5092-1.2612 4.4439-1.4243 4.367-0.0315-0.0149-0.29369-0.14929-0.58265-0.29873-1.9186-0.99223-4.8589-1.1951-8.0297-0.55394-3.0199 0.6106-5.822 1.7774-9.3228 3.8821-4.8528 2.9175-8.5129 6.1616-9.8868 8.7632l-0.34321 0.64989-1.1446 0.2704c-1.6757 0.39586-2.69 0.58967-3.633 0.69418-1.1977 0.13274-4.0722 0.18082-5.8677 0.0981zm-7.1607-21.89c2.9984-0.5175 5.403-2.0464 6.3718-4.0514 0.5444-1.1266 0.64146-2.2437 0.30158-3.4708-0.0518-0.18693-0.037-0.20038 0.15251-0.13877 0.42955 0.13963 1.5029 0.066 2.0487-0.14058 0.72004-0.27252 1.5169-1.0652 1.7808-1.7717 0.25354-0.67855 0.25687-1.6266 8e-3 -2.2917-0.37135-0.99253-1.4179-1.8212-2.4823-1.9657-1.8986-0.25765-3.5221 0.98161-3.7141 2.8351l-0.0582 0.56196-0.61295-0.38779c-1.0597-0.67043-2.5952-1.2034-4.1323-1.4342-0.89925-0.13503-2.9995-0.11615-3.9236 0.0353-1.4085 0.2308-2.8262 0.71197-3.7225 1.2635l-0.41384 0.25463-0.0474-0.52247c-0.093-1.0261-0.80415-2.0157-1.7935-2.4961-0.44539-0.21624-0.60187-0.24425-1.3781-0.24666-0.77073-2e-3 -0.9358 0.0255-1.3779 0.23266-0.61512 0.28829-1.272 0.93045-1.5505 1.5159-0.24375 0.51229-0.3422 1.634-0.19212 2.1891 0.15311 0.56632 0.63617 1.2826 1.1065 1.6408 0.57078 0.43461 1.4422 0.70524 2.1434 0.66568 0.29021-0.0164 0.52759-0.0249 0.5275-0.0189s-0.0555 0.1678-0.12319 0.35959c-0.80172 2.2723 0.7068 4.9649 3.5818 6.3932 2.1309 1.0586 4.9465 1.43 7.4999 0.98934zm-16.673-26.32c0.95873-0.38745 1.3928-0.68423 1.729-1.1823 0.23028-0.34105 0.26754-0.48212 0.2946-1.1153 0.0275-0.64465 5e-3 -0.77801-0.20423-1.2056-0.36527-0.74661-1.4779-1.7988-2.3689-2.2404-0.39758-0.197-0.9033-0.37853-1.1238-0.40339-0.36721-0.0414-0.42612-0.02-0.69962 0.25346-0.45008 0.45008-0.62103 1.3047-0.61901 3.0948 1e-3 1.2647 0.0208 1.4436 0.19926 1.8388 0.24684 0.5467 0.56828 0.89446 1.0201 1.1037 0.51089 0.23653 0.91178 0.20399 1.7726-0.14387zm31.589-0.71945c0.37785-0.18554 0.73233-0.53792 0.94646-0.94085 0.16331-0.30733 0.19003-0.52734 0.21798-1.7951 0.057-2.586-0.37932-3.7322-1.3514-3.5499-1.1938 0.22397-2.863 1.5297-3.4657 2.7111-0.26777 0.52489-0.26531 1.5455 5e-3 2.0647 0.29585 0.56832 0.48301 0.73947 1.1914 1.0895 1.2964 0.64057 1.8241 0.73091 2.4562 0.42051z",
    fill: "#ddafe9",
    stroke: "#ddafe9",
    strokeLinecap: "round",
    strokeWidth: 0.26333
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveStartPage);
export default __webpack_public_path__ + "static/media/waveStartPage.ce1aff3179e4fb55aa2fe45d4c5a55e9.svg";
export { ForwardRef as ReactComponent };